/**
 * Zendesk's answer bot name
 */
export const HELP_CENTER_CHAT_ANSWER_BOT_NAME_230413 = 'HELP_CENTER_CHAT_ANSWER_BOT_NAME_230413';
